export const aboutStyles = (assertBaseUrl) => ({
  'hero-au__background': {
    backgroundImage: `url(${assertBaseUrl}/images/about-us-hero.jpg`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom',
    backgroundSize: 'contain',
    '@media (max-width: 786px)': {
      backgroundImage: `url(${assertBaseUrl}/images/hero-mobile.jpg)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
    },
  },
  fffbox__background: {
    '@media (max-width: 480px)': {
      backgroundImage: `url(${assertBaseUrl}/images/fabfitfun-box-mobile@2x.png)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top',
      backgroundSize: 'contain',
    },
  },
});
